<template>
  <div>
    <div>
      <el-button class="printBtn" type="primary" style="margin: 2mm 0 0 2mm" @click="printHandle">打印</el-button>
    </div>
    <div id="print">
      <div class="printItem" v-for="item in data" :key="item.pkId">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td rowspan="3">
              <div :id="'qrCode' + item.vehicleNo" align="center" />
            </td>
            <td>编号：{{ item.vehicleNo }}</td>
            <td>载重：{{ item.load }}</td>
          </tr>
          <tr>
            <td>长：{{ item.length }}</td>
            <td>宽：{{ item.width }}</td>
          </tr>
          <tr>
            <td>限长：{{ item.lengthLimit }}</td>
            <td>限宽：{{ item.widthLimit }}</td>
          </tr>
          <tr>
            <td colspan="2">名称：{{ item.vehicleName }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      params: {
        data: [],
      },
    };
  },

  created() {
    this.data = JSON.parse(this.$route.query.params);
  },

  mounted() {
    for (let item of this.data) {
      this.$nextTick(() => {
        document.getElementById("qrCode" + item.vehicleNo).innerHTML = "";
        this.bindQRCode(item.vehicleNo);
      });
    }
  },

  methods: {
    bindQRCode(code) {
      new QRCode(document.getElementById("qrCode" + code), {
        text: code,
        width: 90,
        height: 90,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    printHandle() {
      document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
      window.print();
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.printItem {
  width: 76mm;
  height: 36mm;
  border: 1px solid #111;
  page-break-after: always;
  margin-top: 1.5mm;
  margin-left: 2mm;
  display: inline-block;
  font-size: 10px;
  table {
    width: 100%;
    height: 100%;
    tr {
      td {
        border-bottom: 1px solid #111;
        border-right: 1px solid #111;
        padding: 0 3px;
        &:last-child {
          border-right: none;
        }
      }
      &:last-child td {
        border-bottom: none;
      }
    }
  }
}

@media print {
  .printBtn {
    display: none;
  }
}
</style>
